import { useEffect, useState } from "react";
import customAxios from "config";
import { globalJson } from "global/global_json";

/**
 * All fleet categories configured for this company (not just the ones
 * currently assigned to a vehicle) — so the category filter offers every
 * category the site has, matching Template's Common/TabFilters.tsx fetch.
 * `fallback` (the categories derived from the currently-loaded vehicles) is
 * returned until the fetch resolves, and again if it fails or comes back
 * empty, so the filter list is never blank.
 */
export function useFleetCategories(fallback: string[]): string[] {
  const [categoryOptions, setCategoryOptions] = useState<string[]>(fallback);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await customAxios.get("/api/fleet/classes/", {
          params: { company_id: globalJson.prod_company_id },
        });
        if (cancelled) return;
        if (Array.isArray(response.data)) {
          const names: string[] = response.data
            .filter((c: any) => c && !c.removed && typeof c.name === "string")
            .map((c: any) => c.name.trim())
            .filter((n: string) => n.length > 0);
          if (names.length > 0) {
            setCategoryOptions(Array.from(new Set(names)));
          }
        }
      } catch (err) {
        console.error("Fleet classes API error:", err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return categoryOptions;
}
